import React from 'react';
import { Box } from '@gluestack-ui/themed';

import { useChartEntranceGate } from './useChartEntranceGate';

export type ChartEntranceGateProps = {
  replayToken: string | number;
  minHeight: number;
  testID: string;
  children: (ctx: {
    chartMountKey: string;
    entranceUnlocked: boolean;
  }) => React.ReactNode;
};

/**
 * Mounts chart children once 25% visible; remount key changes on replayToken after unlock.
 */
export function ChartEntranceGate({
  replayToken,
  minHeight,
  testID,
  children,
}: ChartEntranceGateProps) {
  const {
    setContainerRef, entranceUnlocked, replayGeneration,
  } = useChartEntranceGate(replayToken);

  const chartMountKey = entranceUnlocked
    ? `chart-${replayGeneration}`
    : 'chart-pending';

  return (
    <Box
      ref={setContainerRef as never}
      testID={testID}
      minHeight={minHeight}
    >
      {children({ chartMountKey, entranceUnlocked })}
    </Box>
  );
}
